import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsDatepickerModule } from '@lcs/shared/datepicker';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { AddPhoneNumberComponent } from './containers/add-phone-number.component';
import { AddPhoneNumberEffects } from './state/add-phone-number.effects';
import * as fromAddPhoneNumber from './state/add-phone-number.reducer';
import { AddPhoneNumberViewComponent } from './views/add-phone-number-view.component';

@NgModule({
   declarations: [AddPhoneNumberComponent, AddPhoneNumberViewComponent],
   imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      MatInputModule,
      MatButtonModule,
      MatTooltipModule,
      MatSelectModule,
      MatDialogModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      MatIconModule,
      EntitySelectModule,
      LcsDatepickerModule,
      StoreModule.forFeature(fromAddPhoneNumber.addPhoneNumberFeatureKey, fromAddPhoneNumber.reducer),
      EffectsModule.forFeature([AddPhoneNumberEffects]),
   ],
})
export class AddPhoneNumberModule {}
